<template>
  <Layout>
    <div class="">
      <PageHeader :items="breadCrumbs" :backButton="null"/>
      <div>
        <div class="row">
          <p class="mb-4">
            This is designed to efficiently view and receive updates for all rented spaces.
          </p>
        </div>
        <div class="row">
          <h5 class="underline-offset" style="width: fit-content;">
            <i class="mdi mdi-alert-circle float-end" v-if="auditOnAlert"></i>
            &nbsp; 
            For Auditing Space
            &nbsp;
          </h5>
          <hr class="custom-hr" />
        </div>
        <div class="d-flex flex-row align-items-center mb-2">
          <div
            class="mdi mdi-information-outline me-3"
            style="color: #3366cc; font-size: 30px !important"
          ></div>
          <div class="text-muted mb-1">
            You can audit your space, check status or view your rental update.
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="float-end">
                  <b-button
                    class="me-2 mb-1 view-btn p-2"
                    :variant="view == 'list'? 'primary':'secondary'"
                    @click="view = 'list'"
                  >
                    <i class="bx bx-list-ul ts-18"></i>
                  </b-button>
                  <b-button class="me-2 mb-1 view-btn p-2" 
                    :variant="view == 'grid'? 'primary':'secondary'"
                    @click="view = 'grid'">
                    <i class="bx bx-grid ts-18"></i>
                  </b-button>
                  <b-button class="me-2 mb-1 view-btn p-2" 
                    variant="secondary" v-if="false"
                    @click="search">
                    test api
                  </b-button>
                </div>
                <div class="d-flex flex-row">
                  <b-form-group
                    description="Search Keyword"
                    class="me-3 custom-fg-width"
                  >
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text class="custom-search-icon">
                          <i class="bx bx-search-alt-2"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        class="rounded-0 custom-input"
                        type="search"
                        v-model="searchValue.search"
                        @keydown.enter.native="search"
                        placeholder="Search here..."
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group><!--end of search-->

                  <b-form-group description="Filter by Date of Audit">
                    <flat-pickr
                      v-model="searchValue.dateRange"
                      :config="rangeOptions"
                      placeholder="Select a date range"
                      class="form-control me-3"
                      style="width: fit-content"
                      @on-change="search"
                    ></flat-pickr>
                  </b-form-group><!--end of date filter-->

                  <b-form-group label-for="audit-status" description="Filter by status">
                    <b-form-select class="form-select rounded-0 rounded-start rounded-end shadow-none" style="width:160px"
                      id="audit-status"
                      v-model="searchValue.status"
                      :options="statusList"
                      @change.native="search"
                    ></b-form-select>
                  </b-form-group><!--end of sstatus filter-->
                </div>
                <!-- <b-col cols="4" class="ta-left">
                </b-col> -->
              </div>
            </div>
            <!-- end card -->
            <div v-if="view=='list'">
              <list-view v-model="auditSpaceList" @viewFullDetails="viewFullDetails"/>
            </div>
            <div v-if="view=='grid'">
              <grid-view v-model="auditSpaceList" @viewFullDetails="viewFullDetails"/>
            </div>
            <div class="sold-item-op text-center my-4 py-4" v-if="auditSpaceList.length == 0">
              <img
                class=""
                height="50"
                src="@/assets/images/store-search.png"
              />
              <div class="">No data to display</div>
            </div>
          </div>
          <div class="row g-0 text-center text-sm-start">
          <!-- end col -->
          <div class="col-sm-12 mt-3"  v-if="auditSpaceTotalRows != 0 && auditSpaceTotalRows > searchValue.rows">
            <div class="row">
              <div class="col">
                <div
                  class="
                    dataTables_paginate
                    paging_simple_numbers
                    float-end
                  "
                >
                  <!-- pagination -->
                  <b-pagination
                    class="pagination-rounded"
                    v-model="searchValue.page"
                    @input="search"
                    :total-rows="auditSpaceTotalRows"
                    :per-page="searchValue.rows"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
            <!-- end col -->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/views/layouts/main.vue";
import {layoutMethods, layoutComputed, auditSpaceMethods, auditSpaceComputed} from "@/state/helpers";
import PageHeader from '@/components/page-header-custom.vue';
import gridView from "@/views/pages/audit-space/grid-view.vue";
import listView from "@/views/pages/audit-space/list-view.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    Layout,
    PageHeader,
    listView,
    gridView,
    flatPickr
  },
  computed: {
    ...layoutComputed,
    ...auditSpaceComputed,
  },
  methods: {
    ...layoutMethods,
    ...auditSpaceMethods,
    viewFullDetails(item){
      console.log(">>>> viewFullDetails",item);
      this.$router.push(
        this.$route.query.redirectFrom || {
          name: "store-campaign-details", params: {id: item.businessId, chid: item.campaignHdrId, pid: item.campaignDtlId}
        }
      )
    },
    async search(){
      this.searchValue.loading = true;
      await this.fetchAuditSpaceList(this.searchValue).then(()=>{
        this.searchValue.loading = false;
      });
    }
  },
  data() {
    return {
      // title: "Audit Space",
      searchValue: {
          search: null,
          page: 1,
          rows: 6,
          status: null,
          dateRange:null,
          loading:false
      },
      rangeOptions: {
        mode: "range",
      },
      statusList: [
        { text: 'All', value: null },
        { text: 'Damaged', value: 'damaged' },
        { text: 'Good', value: 'good' },
      ],
      view: 'grid',
      tblData:[{businessId:1,storeName:"JMA",storePhoto:"https://picsum.photos/536/354"},{businessId:2,storeName:"JMZ",storePhoto:"https://picsum.photos/536/354"}]
    };
  },
  async mounted(){
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Audit Space', to: { name: 'audit-space'} }
      ],
    });
    await this.search(); 
    // this.$toast.showToast('success', "Successful test", "Your top-up was successfully added to you wallet.");
  },
  asyncComputed: {
    async auditOnAlert() {
      var data = false;
      for(let r of this.auditSpaceList){
        //["Damaged"].includes(r.collateralStatus)
        if(['denied',null].includes(r.auditStatus)&& r.contractStatus != 'contract_cancelled'){
          // (item.auditStatus == null||item.auditStatus == 'denied') && item.contractStatus != 'contract_cancelled'
          data = true;
        }
      }
      return data;
    },
  },
};
</script>
<style>
.cstm-badge {
  color: #fff;
  background-color: #0062ff;
  border-radius: 10px;
  margin-left: 10px;
}

.table {
  --bs-table-bg: transparent;
}

.table th {
  background-color: #f5f6f8;
}

.custom-search-icon {
  font-size: 1.5rem;
  background-color: transparent;
  border-right: 0px;
  border-radius: 5px 0px 0px 5px;
}

.custom-input {
  border-left: 0;
  border-radius: 0px 5px 5px 0px !important;
}

.table td {
  width: 400px;
}

.form-check-input {
  border-color: #7e93a059;
}

.underline-offset {
  text-decoration: underline;
  text-underline-offset: 11px;
  text-decoration-thickness: 2px;
  color: #f84b04;
}

.custom-hr {
  border: solid 1px dimgray !important;
  margin-left: 10px;
  width: 98.5%;
}

.custom-fg-width {
  width: 400px;
}
</style>